import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {showAuthModal} from '../../common/function';
import useLogin from '../../common/hook/useLogin';
import useTypedSelector from '../../common/hook/useTypedSelector';
import {useFetchInfo} from '../../common/util/fetch';
import {showSortToast} from '../common';
import {actions, ActionType} from '../state/action';
import {
  ICommentLikeStatus,
  ICommentSort,
  IUseCommentReturnValue,
} from '../type';

// TODO: 작품/에피소드/이벤트 댓글 통합
export default function useEventComment(
  eventId: number
): IUseCommentReturnValue {
  const dispatch = useDispatch();
  const [ids, sort, commentMap, sectionMap] = useTypedSelector(({comment}) => [
    comment.eventCommentList.ids,
    comment.eventCommentList.sort,
    comment.eventCommentList.commentMap,
    comment.eventCommentList.sectionMap,
  ]);
  const fetchCommentsActionType = ActionType.FetchEventComments;
  const fetchCommentsFetchKey = eventId;
  const {totalCount} = useFetchInfo(
    fetchCommentsActionType,
    fetchCommentsFetchKey
  );
  const {isLogin} = useLogin();

  const toggleSort = useCallback(() => {
    const newSort = sort === 'createdDt' ? 'like' : 'createdDt';
    showSortToast(newSort);
    dispatch(actions.setEventCommentSort(newSort));
  }, [dispatch, sort]);

  const postComment = useCallback(
    (content: string, isSpoiler: boolean) => {
      dispatch(
        actions.fetchPostEventComment({
          eventId,
          content,
          isSpoiler,
        })
      );
    },
    [dispatch, eventId]
  );

  const fetchComments = useCallback(
    (sort: ICommentSort, isFirst?: boolean) => {
      dispatch(actions.fetchEventComments({eventId, sort}, isFirst));
    },
    [dispatch, eventId]
  );

  const fetchReplyComments = useCallback(
    (parentId: number, isFirst?: boolean) => {
      dispatch(actions.fetchEventReplyComments(parentId, isFirst));
    },
    [dispatch]
  );

  const postReplyComment = useCallback(
    (parentId: number, content: string) => {
      dispatch(
        actions.fetchPostEventReplyComment({
          parentId,
          content,
          eventId,
        })
      );
    },
    [dispatch, eventId]
  );

  const deleteComment = useCallback(
    (commentId: number) => {
      dispatch(actions.fetchDeleteEventComment(eventId, commentId));
    },
    [dispatch, eventId]
  );

  const changeLikeStatus = useCallback(
    (commentId: number, likeStatus: ICommentLikeStatus) => {
      if (isLogin) {
        dispatch(actions.fetchEventLikeStatus(commentId, likeStatus));
      } else {
        showAuthModal();
      }
    },
    [dispatch, isLogin]
  );

  const toggleReplyComments = useCallback(
    (commentId: number, isOpen: boolean) => {
      dispatch(actions.setEventReplyOpen(commentId, isOpen));
    },
    [dispatch]
  );

  return {
    ids,
    sort,
    commentMap,
    sectionMap,
    totalCount,
    fetchCommentsActionType,
    fetchCommentsFetchKey,
    fetchComments,
    fetchReplyComments,
    postComment,
    postReplyComment,
    deleteComment,
    toggleSort,
    changeLikeStatus,
    toggleReplyComments,
  };
}
